import React, { useEffect } from "react";

import { useState} from "react";
import { useNavigate ,useParams} from "react-router-dom";

import { faceBookIcon,googleIcon,logo,bannerIcon,congratsIcon } from "../../../images";

import { InputPassword,ButtonComponent,SwitchComponent,InputSelect } from "../../../commonComponents";
import { Form, Input } from "antd";

import './confirmPassword.css';
import { useSelector,useDispatch } from "react-redux";
import { passwordConfirmationInstructor } from "../../../redux/instructorRegister/action";
import InstructorComponent from "../login";

let ConfirmPassword = () =>{

   
    const navigate = useNavigate();

    let dispatch = useDispatch()
    let[passwordDetails,setPasswordDetails] = useState({
      password:"",
      confirm_password:""
    })

    const [form] = Form.useForm();

    let [passwordSuccess,setPasswordSuccess] = useState(false)
    let [email,setEmail] = useState("");
    let passwordOk = useSelector((state)=>state.instructorRegisterReducer.passwordMatch);


    let handleChange = (e,type) =>{
      if (e) {
        setPasswordDetails({...passwordDetails,[type.name]:e.target.value})
      }
    }
    const routeParams = useParams();
    useEffect(()=>{
     
    let data = routeParams.id.replace('id=', '')
    setEmail(data)
    },[])
    
    const onFinish = (values) => {
      console.log('Success:', values);
      // setVerifyPage(true)
      if (values) {
       let passwordPayload= {
          "operation_type": "reset_password",
          "op_field_details":{
          "username": email,
          "confirm_password":passwordDetails.password,
          "re_enter_password":passwordDetails.confirm_password
          }
      }
      dispatch(passwordConfirmationInstructor(passwordPayload))
      }
      
    };

    useEffect(()=>{
      if (passwordOk) {
        navigate("/")
      }
    },[passwordOk])

    return (
<>
      {!passwordSuccess ?
        <div className="App">
      <div className='logo'>
         <img src= {bannerIcon} className='bannerImage'/>

      </div>
      <div className='login'>
        <div className='form'>
          <div className='formLogo'>
          <img src={logo}/>
          <img src= {congratsIcon} className=''/>
        <span>{email} have successfully registered</span>
        <span>let's create password and proceed to your account</span>
          </div>

            <>
            <Form 
              autoComplete="off"
              layout="vertical"
              form={form}
                onFinish={onFinish}>
              <div className='fields'>
              <Form.Item
                label="password"
                name="password"
                
             rules={[
                    {
                      required: true,
                      message: 'Password is required',
                     
                    },
                    {
                      required:true,
                      min:8,
                      message: "Password should atleast 8 characters with special and uppercase",
                    }
                  ]}
                >
                      <div>
                        <Input.Password 
                        value={passwordDetails.password}
                         name={"password"}
                        className='inputField' placeholder="Enter password"
                        onChange={(e)=>handleChange(e,{name:"password"})}/>
                      </div>
                  </Form.Item>
                  </div>

                <div className='fields'>

                <Form.Item
                label="Confirm Password"
                name="confirm_password"
                dependencies={['password']}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your password!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('The new password that you entered do not match!'));
                    },
                  }),
                ]}
                    >
                    {/* <div> */}
                    <Input.Password 
                    value={passwordDetails.confirm_password}
                     name={"confirm_password"}
                    //  className='inputField'
                     onChange={(e)=>handleChange(e,{name:"confirm_password"})}
                      placeholder="Enter password"/>
                    {/* </div> */}
                </Form.Item>
                  </div>

                    <div className='fields'>
                        <div className='switchInConfirm'>
                            <div><SwitchComponent /><span className='rememberMe'>Remember me</span></div>
                            <div className='forgotpassword'>
                                
                            </div>
                        </div>
                    </div>
                    <div className='fields'>
              <ButtonComponent type="primary" className='btnLogin' htmlType={"Submit"} value={'Proceed To Login'}></ButtonComponent>
             
                   </div>
                   </Form>
            </>
        </div>
      </div>
    </div>
    : <InstructorComponent/>}
    </>
    )
}

export default ConfirmPassword